<script lang="ts">
	import { Responsive } from "responsive"
	import { ToastStore } from "./ToastStore"

	interface Props {
		topMargin?: string
		bottomMargin?: string
		errorBackground?: string
		errorColor?: string
	}

	let {
		topMargin = "calc(var(--header-height) + 0.5rem)",
		bottomMargin = "5rem",
		errorBackground = undefined,
		errorColor = undefined,
	}: Props = $props()

	let textContent = $state()
	let isOpen = $state()
	let type = $state("text")

	let action: Function = $state()
	let actionString: string = $state()
	let isMobile = $derived(Responsive.isMobile)

	ToastStore.subscribe((v) => {
		isOpen = v.isOpen
		if (v.isOpen) {
			textContent = v.textContent
			type = v.type
			if ("action" in v) {
				action = v.action
				actionString = v.actionString
			} else {
				action = undefined
				actionString = undefined
			}
		}
	})
</script>

<div
	class="Toast {type} {isOpen ? 'open' : ''}"
	class:isMobile
	style={`--top-margin: ${topMargin}; --bottom-margin: ${bottomMargin}; ${
		type === "error" && errorColor ? `color: ${errorColor};` : ""
	} ${type === "error" && errorBackground ? `background-color: ${errorBackground};` : ""}`}
>
	<button class="close-toast-button icon" onclick={() => ToastStore.set({ isOpen: false })}
	></button>
	{#if type === "error"}
		<span class="type-indicator"> ⚠ </span>
	{:else if type === "success"}
		<span class="type-indicator">✓</span>
	{/if}
	{textContent}

	{#if action}
		<br />
		<button
			class="outline-button alt small"
			onclick={() => {
				action()
				ToastStore.set({ isOpen: false })
			}}>{actionString}</button
		>
	{/if}
</div>

<style>
	.Toast {
		z-index: 120;
		user-select: none;
		font-size: var(--text-small);
		position: fixed;
		border-radius: var(--br);
		color: var(--color-text-light);
		right: 1rem;
		background-color: var(--color-bg-dark);
		box-shadow: var(--shadow-medium);
		width: 16rem;
		padding: 0.5rem 2rem 0.5rem 0.75rem;
		background-color: var(--color-bg-dark);
		transform: translateX(200%);
		top: var(--top-margin);
		transition: transform var(--transition-duration) cubic-bezier(0.4, 0, 0.2, 1);
	}

	.Toast.open {
		transform: translateX(0%);
	}

	.type-indicator {
		margin-right: 0.5rem;
		float: left;
	}

	.Toast.error {
		background-color: var(--red);
		color: var(--color-text-light);
	}

	.Toast.success {
		background-color: var(--ct-green);
	}

	.close-toast-button {
		z-index: 20;
		padding: 0.5rem;
		position: absolute;
		top: 0;
		right: 0;
		transform: unset;
	}

	.close-toast-button::after {
		content: "\00d7";
		font-family: var(--heading-font);
		font-size: var(--text-h5);
	}

	.Toast.error .close-toast-button {
		/* color: var(--color-bg-dark); */
	}

	.Toast.success .close-toast-button:hover,
	.Toast.success .close-toast-button:focus-visible {
		color: var(--light);
	}

	.outline-button {
		margin-top: 1rem;
	}

	.Toast.isMobile {
		width: calc(100% - 2rem);
		background-color: var(--color-bg-opaque);
		height: fit-content;
		top: 0;
		right: 0;
		left: 0;
		margin-left: auto;
		margin-right: auto;
		transform: translateY(calc(var(--bottom-margin) * -1));
	}

	.Toast.isMobile.open {
		transform: translateY(1rem);
	}
</style>
